module.exports = __webpack_public_path__ + "static/media/12_blanco.d7b439bf.svg";